import React from 'react'
import styled from 'styled-components'

export const IOSAppAlert = () => {
  return (
    <Root>
      <Link
        onClick={() =>
          document.querySelector('#mobile-app-section').scrollIntoView({
            behavior: 'smooth'
          })
        }
      >
        Check out our brand new iOS app!
      </Link>{' '}
      🎉📱
    </Root>
  )
}

const Root = styled.div`
  padding: 15px 0;
  background-color: #ebf1fc;
  text-align: center;
  color: #232323;
  font-style: normal;
  font-size: 18px;
  line-height: 120%;
  letter-spacing: -0.05em;
`

const Link = styled.a`
  cursor: pointer;
  text-decoration: underline !important;
  margin-right: 5px;
`
